import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ErrorList } from "../models/commons.model";
import { AuthService } from "../../core/services/auth.service";

@Injectable({
	providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private service: AuthService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(catchError(err => {
			const sessionRejected =
				err.status === 401 ||
				(err.status === 403 && !request.url.includes('/api/auth/'));
			if (sessionRejected) {
				this.service.disallow();
				location.reload();
			}

			let errorList: ErrorList;
			if (err.error != null && err.error.hasError === true) {
				errorList = new ErrorList(err.error);
			} else {
				errorList = new ErrorList(err.statusText);
			}
			return throwError(errorList);
		}));
	}

}
